import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { GrantDiscordAccessInput_InputAdapter_instance1gizlq5c0bi2d as GrantDiscordAccessInput_InputAdapter_instance } from '../type/adapter/GrantDiscordAccessInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessMutation_VariablesAdapterClass;
function GrantDiscordAccessMutation_VariablesAdapter() {
  if (GrantDiscordAccessMutation_VariablesAdapterClass === VOID) {
    class $ {
      z6f(writer, value, customScalarAdapters, withDefaultValues) {
        writer.n4a('input');
        obj(GrantDiscordAccessInput_InputAdapter_instance).t3x(writer, customScalarAdapters, value.y6f_1);
      }
    }
    initMetadataForObject($, 'GrantDiscordAccessMutation_VariablesAdapter');
    GrantDiscordAccessMutation_VariablesAdapterClass = $;
  }
  return GrantDiscordAccessMutation_VariablesAdapterClass;
}
var GrantDiscordAccessMutation_VariablesAdapter_instance;
function GrantDiscordAccessMutation_VariablesAdapter_getInstance() {
  return GrantDiscordAccessMutation_VariablesAdapter_instance;
}
//region block: init
GrantDiscordAccessMutation_VariablesAdapter_instance = new (GrantDiscordAccessMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  GrantDiscordAccessMutation_VariablesAdapter_instance as GrantDiscordAccessMutation_VariablesAdapter_instance3r6nddgmqgo6x,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation_VariablesAdapter.mjs.map
